module.exports = __webpack_public_path__ + "967.application.7677d11.default.worker.js"